<mat-toolbar class="header">
  <div class="menu-logo-container">
    @if (displaySideNavButton()) {
      <button aria-label="Open menu" type="button" class="menu-button" (click)="menuClick()" mat-icon-button>
        <rma-icon glyph="menu" />
      </button>
    }

    @if (!hasSideNav()) {
      <rma-header-logo />
    }
  </div>

  <rma-nav-subscription-header />

  @if (trialDays() && !isSubscribed()) {
    <rma-trial-remaining-days [trialDays]="trialDays()" />
  }

  <div class="align-the-ctas">
    <button type="button" class="header-icon" (click)="facade.openSearchModal()" mat-icon-button color="primary">
      <rma-icon glyph="search" />
    </button>

    @if (facade.helpRoute()) {
      <a type="button" class="header-icon" [href]="facade.helpRoute()" mat-icon-button color="primary" target="_blank">
        <rma-icon glyph="help_outline" />
      </a>
    }

    <rma-notification-bell />
  </div>
</mat-toolbar>
